import {
  DealItem,
  DealItemWithVersions,
} from '@/lib/graphql/generated/graphql';
import { rowEditingAtomFamily } from '@/states/editing-cell.state';
import { Row } from '@tanstack/react-table';
import { useAtomValue } from 'jotai';

export function getEditingRowId(row: Row<DealItemWithVersions>): string {
  return row.subRows.length > 1
    ? row.id
    : (row.original?.activeVersion?.id ?? row.id);
}

/**
 * Returns whether the given table cell is currently being edited.
 *
 * Subscribes only to this row's per-row atom from rowEditingAtomFamily.
 * When another row starts editing, this component will NOT re-render.
 *
 * Use this hook inside a React component defined at module level (not inside
 * the cell render function directly, since cell is not a React component).
 */
export function useIsCellEditing(
  row: Row<DealItemWithVersions>,
  field: keyof DealItem,
  allowParent = true
): boolean {
  const isParent = row.subRows.length > 1;
  const rowId = getEditingRowId(row);
  const editingField = useAtomValue(rowEditingAtomFamily(rowId));
  return (!isParent || Boolean(allowParent)) && editingField === field;
}
